import gasTableEnhance from './gasTableEnhance'

export default {
  mixins: [gasTableEnhance],
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: { pageNum: 1, pageSize: 10, keyword: '' },
      dialogVisible: false,
      dialogTitle: '新增',
      form: {},
      orgOptions: []
    }
  },
  created() {
    if (this.loadOrgOptions) this.fetchOrgOptions()
    if (this.autoLoad !== false) this.loadData()
  },
  methods: {
    async fetchOrgOptions() {
      const { gasApi } = await import('@/api/gas')
      const res = await gasApi.orgOptions()
      this.orgOptions = res.data || []
    },
    orgName(orgId) {
      const hit = (this.orgOptions || []).find(o => o.orgId === orgId)
      return hit ? hit.orgName : orgId
    },
    async loadData() {
      if (!this.listApi) return
      this.loading = true
      try {
        const res = await this.listApi(this.query)
        const data = res.data || {}
        this.list = data.records || []
        this.total = Number(data.total || 0)
      } finally {
        this.loading = false
      }
    },
    search() {
      this.query.pageNum = 1
      this.loadData()
    },
    resetQuery(extraReset) {
      const pageSize = this.query.pageSize
      this.query = { pageNum: 1, pageSize, keyword: '' }
      if (typeof extraReset === 'function') extraReset()
      this.loadData()
    },
    handleSizeChange(size) {
      this.query.pageSize = size
      this.query.pageNum = 1
      this.loadData()
    },
    handleCurrentChange(page) {
      this.query.pageNum = page
      this.loadData()
    },
    openCreate(defaultForm) {
      this.dialogTitle = '新增'
      this.form = { ...(defaultForm || {}) }
      this.dialogVisible = true
    },
    openEdit(row, defaultForm) {
      this.dialogTitle = '编辑'
      this.form = { ...(defaultForm || {}), ...row }
      this.dialogVisible = true
    },
    async submitForm() {
      if (!this.saveApi) return
      await this.saveApi(this.form)
      this.$message.success('保存成功')
      this.dialogVisible = false
      this.loadData()
      if (this.afterSave) this.afterSave()
    },
    async removeRow(row) {
      await this.$confirm('确认删除该记录？', '提示', { type: 'warning' })
      await this.removeApi(row[this.idField])
      this.$message.success('删除成功')
      this.loadData()
    }
  }
}
